import { useEffect, useRef, useState } from "react";
import RWATable from "./components/RWATable";
import RWATypeSelectionModal from "./components/TypeSelectionModal";
import toast from "react-hot-toast";
import useRwas from "../../../hooks/useRwas";
import useCompany from "../../../hooks/useCompany";
import RWAMenu from "./components/RWAMenu";

export default function RWA() {
  const { activeCompany: company } = useCompany();
  const [rwas, setRwas] = useState([]);
  const intervalRef = useRef(null);

  const { getAllRWAs } = useRwas();

  const loadRwas = async () => {
    try {
      const fetched = await getAllRWAs(company.id);
      setRwas(fetched);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load RWAs");
    }
  };

  useEffect(() => {
    if (company) loadRwas();
    // eslint-disable-next-line
  }, [company]);

  useEffect(() => {
    const hasPending = rwas.some((rwa) => !rwa.smartContractAddress);
    if (hasPending && company) {
      intervalRef.current = setInterval(() => loadRwas(), 3000);
    }
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line
  }, [rwas, company]);

  return (<div className="2xl:p-6 p-3">
    <RWAMenu />
    <RWATable rwas={rwas} />
    <RWATypeSelectionModal />
</div>);
}